import type { CompareV2SettingsType } from "../redux/reducers/CompareV2SettingsReducer";
import type { CommonSettingsType } from "../../../common-deprecated/settings/fetchCommonSettings";

export const loadEtaValuesInCompare = (settings: CompareV2SettingsType): boolean => {
    return !!settings.loadEtaValuesInCompare;
};

export const hideReviewScoresInCompare = (
    compareSettings: CompareV2SettingsType,
    commonSettings: CommonSettingsType,
): boolean => {
    // This is not yet supported in lexus endpoints thus it doesn't need to be loaded if lexus.
    return !!compareSettings.hideReviewScoresInCompare || commonSettings.brand === "lexus";
};
